import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from './ActionButton';
import noop from '../../../util/noop';
import i18n from '../../../i18n/translate';

const EditActionButton = props => {
  const { action = noop, actionType, keyField, row = {}, selectMember } = props;

  const getActionProps = () => {
    switch (actionType) {
    case 'route':
      return {
        action: `/${row[keyField]}`,
        actionType: 'link'
      };
    case 'select':
      return {
        action: selectMember ?
          () => selectMember(row[keyField]) :
          action,
        actionType: 'callToAction'
      };
    default:
      return {};
    }
  }

  return (
    <ActionButton
      icon="edit"
      title={i18n.t("Edit")}
      tooltip={i18n.t("Edit")}
      {...props}
      {...getActionProps()}
    />
  );
};

EditActionButton.propTypes = {
  action: PropTypes.func,
  actionType: PropTypes.oneOf(['route', 'select', 'link', 'externalLink', 'callToAction']),
  keyField: PropTypes.string,
  row: PropTypes.object.isRequired,
  selectMember: PropTypes.func
};

EditActionButton.defaultProps = {
  keyField: 'id',
  actionType: 'select'
};

export default EditActionButton;
